export const generateRandomColor = (): string => {
  const colors = [
    '#2a85ff',
    '#83bf6e',
    '#ff6a55',
    '#8e59ff',
    '#ffbc99',
    '#cabdff',
    '#b1e5fc',
    '#b5e4ca',
    '#ffd88d',
  ]

  return colors[Math.floor(Math.random() * colors.length)]
}